/**
 * @fileoverview
 *   List of whitespace sensitive HTML tag names
 * @longdescription
 *   ## Use
 *
 *   ```js
 *   import {whitespaceSensitiveTagNames} from 'html-whitespace-sensitive-tag-names'
 *
 *   whitespaceSensitiveTagNames
 *   //=> ['pre', 'script', 'style', 'textarea']
 *   ```
 *
 *   ## API
 *
 *   ### `whitespaceSensitiveTagNames`
 *
 *   List of whitespace sensitive HTML tag names (`string[]`).
 */

export const whitespaceSensitiveTagNames = [
  'pre',
  'script',
  'style',
  'textarea'
]
